/** Display fallback when the install has not saved an organization name yet. */
export const FALLBACK_ORGANIZATION_NAME = 'this organization';
